import { Bug, AlertCircle, Database, Server, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useDebugConsoleStore } from "@/stores/debugConsoleStore";
import { useDebugLogs } from "@/hooks/useDebugLogs";
import { Badge } from "@/components/ui/badge";
import { useState, useEffect } from "react";
import { debugContext } from "@/lib/debugContext";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export default function DebugButton() {
  const { toggleVisibility, isVisible } = useDebugConsoleStore();
  const { logs } = useDebugLogs();
  const [errorCount, setErrorCount] = useState(0);
  const [warningCount, setWarningCount] = useState(0);
  const [dbErrorCount, setDbErrorCount] = useState(0);
  const [apiErrorCount, setApiErrorCount] = useState(0);

  // Conta il numero di errori e warning per tipologia
  useEffect(() => {
    const errors = logs.filter(log => log.level === 'error');
    const warnings = logs.filter(log => log.level === 'warn');
    const dbErrors = errors.filter(log => 
      log.component?.toLowerCase().includes('database') || 
      log.message.toLowerCase().includes('database') ||
      log.message.toLowerCase().includes('db') ||
      log.message.toLowerCase().includes('sql')
    );
    const apiErrors = errors.filter(log => 
      log.component?.toLowerCase().includes('api') || 
      log.message.toLowerCase().includes('api') ||
      log.message.toLowerCase().includes('http')
    );
    
    setErrorCount(errors.length);
    setWarningCount(warnings.length);
    setDbErrorCount(dbErrors.length);
    setApiErrorCount(apiErrors.length);
    
    // Log per verificare che il componente funzioni
    debugContext.logInfo('Debug Button stato aggiornato', { 
      errorCount: errors.length,
      warningCount: warnings.length,
      dbErrorCount: dbErrors.length,
      apiErrorCount: apiErrors.length,
      logsCount: logs.length
    }, { component: 'DebugButton' });
  }, [logs]);
  
  // Funzione che gestisce il click sul pulsante
  const handleButtonClick = () => {
    debugContext.logInfo('Debug Button cliccato', { 
      currentVisibility: isVisible
    }, { component: 'DebugButton' });
    
    toggleVisibility();
  };

  // Debug button nascosto per produzione
  return null;
}